import * as React from "react"
import { clx } from "../utils/clx"
/**
 * This component is based on the `div` element and supports all of its props
 */
const Container = React.forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<"div">
>(({ className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={clx(
        "border border-ui-border-strong bg-ui-bg-base w-full rounded-rounded px-8 pb-8 pt-6",
        className
      )}
      {...props}
    />
  )
})
Container.displayName = "Container"

export { Container }
